import { MintInfo } from "../../../config/solana.types";
import InputMaxButton from "./InputMaxButtonClaim";

type Props = {
  handleClick?: ((balance: string) => void) | void;
  activeMint: MintInfo;
  balance: number | null;
};

const InputMaxButtonMint = ({ handleClick, activeMint, balance }: Props) => {
  return (
    <InputMaxButton
      handleClick={handleClick}
      assetCurrency={activeMint.displayName ?? activeMint.name}
      assetDecimals={activeMint.decimals}
      balance={balance}
    />
  );
};

export default InputMaxButtonMint;
